import React, { useEffect, useState } from 'react'
import { Box, Container, Stack, Typography } from '@mui/material'
import ApartmentIcon from '@mui/icons-material/Apartment';
import { customStyles, spaceBetween } from '../../../styles';
import { LightText } from '../../helpers';
import { SecondaryText } from '../../helpers/text/SecondaryText';
import { PreviewStackContainer } from './PreviewStackContainer';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const style = {
   color: customStyles.colors.main
}
export const SendTo = () => {
   const { account } = useSelector(state => state.order)
   
   const { alias, street, extNumber, intNumber, colony, postalCode,  name, reciever} = account !== null && account
   const [address, setAddress] = useState('')
   const navigate = useNavigate()
   
      useEffect(() => {
         !account && navigate('/dashboard/content')
      }, [])
   useEffect(() => {
      account && setAddress(`${street}, No Ext#${extNumber} ${ intNumber && 'No Int# ' + intNumber }, ${ colony }, ${ postalCode }`)
   }, [account])
  return (
   <PreviewStackContainer text="Enviar a esta dirección">
      <ApartmentIcon sx={style}/>
     {
      account && 
      <Stack>
      <Typography component="p" variant="body1">{ alias }</Typography>
      <SecondaryText variant="body2" text={address} />
      <Typography component="p" variant="body2">{reciever}</Typography>
   </Stack>
     }
   </PreviewStackContainer>
  )
}
